import { clsx } from 'clsx'
import { Loader2 } from 'lucide-react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  fullScreen?: boolean
  className?: string
}

export default function LoadingSpinner({
  size = 'md',
  fullScreen = false,
  className,
}: LoadingSpinnerProps) {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/80 z-50">
        <Loader2
          className={clsx('animate-spin text-primary-600', sizes[size], className)}
        />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center p-8">
      <Loader2
        className={clsx('animate-spin text-primary-600', sizes[size], className)}
      />
    </div>
  )
}
